
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shareable/[id]",
      function () {
        return require("private-next-pages/shareable/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shareable/[id]"])
      });
    }
  